module.exports = __webpack_public_path__ + "static/scale-model-of-overland-park-kansas-17c18f3cc1c6ea4ae17bce77229703de.png";